var _path, _circle, _path2, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinefoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 40,
    viewBox: "0 0 139 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38773 28.2061L1.10225 12.5335H3.03072L6.30604 25.2981H6.45909L9.79564 12.5335H11.9384L15.2749 25.2981H15.428L18.7033 12.5335H20.6318L16.3463 28.2061H14.3872L10.9282 15.717H10.8058L7.3468 28.2061H5.38773ZM62.6772 12.5335V28.2061H60.8406L52.3002 15.9006H52.1472V28.2061H50.2493V12.5335H52.0859L60.6569 24.8695H60.8099V12.5335H62.6772ZM77.0708 28.2061V12.5335H86.5294V14.2171H78.9687V19.5127H86.0397V21.1962H78.9687V26.5225H86.6519V28.2061H77.0708ZM100.546 28.2061V12.5335H109.944V14.2171H102.444V19.5127H109.24V21.1962H102.444V28.2061H100.546ZM137.014 20.3698C137.014 22.0227 136.715 23.4512 136.118 24.6552C135.522 25.8592 134.703 26.7878 133.662 27.4408C132.621 28.0938 131.432 28.4203 130.096 28.4203C128.759 28.4203 127.57 28.0938 126.53 27.4408C125.489 26.7878 124.67 25.8592 124.073 24.6552C123.476 23.4512 123.178 22.0227 123.178 20.3698C123.178 18.7168 123.476 17.2883 124.073 16.0843C124.67 14.8803 125.489 13.9518 126.53 13.2987C127.57 12.6457 128.759 12.3192 130.096 12.3192C131.432 12.3192 132.621 12.6457 133.662 13.2987C134.703 13.9518 135.522 14.8803 136.118 16.0843C136.715 17.2883 137.014 18.7168 137.014 20.3698ZM135.177 20.3698C135.177 19.0127 134.95 17.8674 134.496 16.9337C134.047 16.0001 133.437 15.2935 132.667 14.814C131.902 14.3344 131.045 14.0946 130.096 14.0946C129.147 14.0946 128.287 14.3344 127.517 14.814C126.752 15.2935 126.142 16.0001 125.688 16.9337C125.239 17.8674 125.014 19.0127 125.014 20.3698C125.014 21.7268 125.239 22.8722 125.688 23.8058C126.142 24.7394 126.752 25.446 127.517 25.9256C128.287 26.4051 129.147 26.6449 130.096 26.6449C131.045 26.6449 131.902 26.4051 132.667 25.9256C133.437 25.446 134.047 24.7394 134.496 23.8058C134.95 22.8722 135.177 21.7268 135.177 20.3698Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1947,
    cy: 9.11658,
    r: 1.6615,
    fill: "#0094FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5541 12.8913V12.4395H34.8353V12.8913H34.5332V13.9457H34.8353V19.5942C34.3319 20.021 33.204 21.1005 32.7207 22.0043V39.251C32.7459 39.3514 32.8415 39.5673 33.0228 39.6276H39.3667C39.5479 39.5673 39.6436 39.3514 39.6688 39.251V22.0043C39.1854 21.1005 38.0576 20.021 37.5541 19.5942V13.9457H37.8562V12.8913H37.5541Z",
    fill: "url(#paint0_linear_1941_23302)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1703,
    cy: 12.0335,
    r: 7.55226,
    transform: "rotate(0.0569805 36.1703 12.0335)",
    stroke: "url(#paint1_linear_1941_23302)",
    strokeWidth: 1.51045
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1941_23302",
    x1: 36.1947,
    y1: 36.1535,
    x2: 36.1947,
    y2: 20.2938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1941_23302",
    x1: 36.1665,
    y1: 8.33291,
    x2: 36.1784,
    y2: 20.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinefoLogo);
export default __webpack_public_path__ + "static/media/winefo-logo.98f7507cc75728626781de3f3a910bee.svg";
export { ForwardRef as ReactComponent };